import { render, staticRenderFns } from "./InviteUserButton.vue?vue&type=template&id=9c09b406"
import script from "./InviteUserButton.vue?vue&type=script&lang=ts"
export * from "./InviteUserButton.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports